export var typeDefaultValues = {
    __proto__: null,
    $BgNumber: NaN,
    $Bgint: 0,
    $Bguint: 0,
    $BgBoolean: false
};
